import { render } from "./CategoryRenderer.vue?vue&type=template&id=10bf954a&ts=true"
import script from "./CategoryRenderer.vue?vue&type=script&lang=ts"
export * from "./CategoryRenderer.vue?vue&type=script&lang=ts"

import "./CategoryRenderer.vue?vue&type=style&index=0&id=10bf954a&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/product-category-selector/components/CategoryRenderer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "10bf954a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('10bf954a', __exports__)) {
    api.reload('10bf954a', __exports__)
  }
  
  module.hot.accept("./CategoryRenderer.vue?vue&type=template&id=10bf954a&ts=true", () => {
    api.rerender('10bf954a', render)
  })

}


export default __exports__